import React, { FC, Fragment } from 'react'
import {
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerFooter,
  DrawerHeader,
  Heading,
  Text,
  Stack,
} from '@chakra-ui/react'

import { Empty, Loader } from 'components'

import GambiarraFilterTags from 'InstitutionalManagement/components/SalaryFilterTags'
import CustomFormCostCenterCardToSelect from './components/CustomFormCostCenterCardToSelect'
import { useCustomFormCostCenterSelectionDrawerManager } from '../../contexts/CustomFormCostCenterSelectionDrawerManager/Provider'

type Props = {
  onClose: () => void
}

const SelectCostCenterOnCustomForm: FC<Props> = ({ onClose }) => {
  const { loadingCostCenters, costCenters, setView, filter, setFilter } =
    useCustomFormCostCenterSelectionDrawerManager()

  return (
    <>
      <DrawerCloseButton />

      <DrawerHeader>
        <Text>Centros de custo disponíveis</Text>
        <Heading color="primary">Selecione uma centro de custo</Heading>
      </DrawerHeader>

      <DrawerBody overflowY="auto">
        <GambiarraFilterTags px={4} pb={4} salaryFilter={filter} setSalaryFilter={setFilter} />

        {loadingCostCenters ? (
          <Loader text={'Carregando centros de custo disponíveis'} />
        ) : (
          <Fragment>
            {costCenters.length > 0 ? (
              <Stack>
                {costCenters.map((costCenter) => (
                  <CustomFormCostCenterCardToSelect key={costCenter.id} costCenter={costCenter} onClose={onClose} />
                ))}
              </Stack>
            ) : (
              <Empty title={'Nenhum centros de custo encontrado'} description="Sua busca não retornou registros" />
            )}
          </Fragment>
        )}
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={() => setView('SEARCH_COST_CENTER')}>
          Voltar
        </Button>

        <Button onClick={onClose}>Concluir</Button>
      </DrawerFooter>
    </>
  )
}

export default SelectCostCenterOnCustomForm
